import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { lightBlue } from "styles/colors.module.scss";
import { MdContentCopy } from "react-icons/md";
import { SuggestionType } from "constants/MessageConstants";
import MessageSuggestionReceiver from "services/MessageSuggestionReceiver";
import { IoMdAttach } from "react-icons/io";
import "./SuggestionCard.scss";
import { getFileObjectFromUrl } from "utils/Common";

function SuggestionCard(props) {
  const { suggestion, suggestionInfo, attachments } = props;
  const copySuggestionToActiveConversation = () => {
    MessageSuggestionReceiver.recieveSuggestion({
      ...suggestion,
      suggestionInfo,
    });
  };

  const getFileObjectFromAttachmentsOrUrl = (fileUrl) => {
    const attachmentOfFileUrl = attachments.find((a) => a.fileUrl === fileUrl);
    if (attachmentOfFileUrl) {
      return attachmentOfFileUrl;
    }
    return getFileObjectFromUrl(fileUrl);
  };

  const renderSuggestionBasedOnType = () => {
    if (suggestion.suggestionType === SuggestionType.TEXT) {
      return suggestion.content;
    }
    if (suggestion.suggestionType === SuggestionType.ATTACHMENT) {
      const suggestionFileUrl = suggestion.content;
      const { name } = getFileObjectFromAttachmentsOrUrl(suggestionFileUrl);
      return name;
    }
  };
  const renderIconBasedOnType = () => {
    switch (suggestion.suggestionType) {
      case SuggestionType.TEXT:
        return (
          <MdContentCopy
            className="copy-msg-icon"
            color={lightBlue}
            size="15"
            onClick={copySuggestionToActiveConversation}
          />
        );
      case SuggestionType.ATTACHMENT:
        return (
          <IoMdAttach
            className="copy-msg-icon"
            color={lightBlue}
            size="15"
            onClick={copySuggestionToActiveConversation}
          />
        );
      default:
        return "";
    }
  };
  return (
    <div className="suggestion-message-card">
      <div className="suggestion-message">{renderSuggestionBasedOnType()}</div>
      <div className="copy-div">{renderIconBasedOnType()}</div>
    </div>
  );
}

SuggestionCard.propTypes = {
  suggestion: PropTypes.shape({
    content: PropTypes.string,
    type: PropTypes.oneOf([SuggestionType.TEXT, SuggestionType.ATTACHMENT]),
  }).isRequired,
  suggestionInfo: PropTypes.shape({
    messageIdOfSuggestion: PropTypes.string,
    suggestionIndex: PropTypes.number,
  }).isRequired,
  attachments: PropTypes.array,
};

SuggestionCard.defaultProps = {
  attachments: [],
};

const mapStateToProps = (state) => ({
  attachments: state.attachments,
});

export default connect(mapStateToProps)(SuggestionCard);
